
class Folder {
    constructor(name, parent, depth=0) {
        this.name = name;
        this.parent = parent;
        this.subFolders = [];
        this.items = [];
        this.depth = depth;
    }

    isDynamic() {
        return false;
    }

    isRoot() {
        return this.parent === undefined;
    }

    /**
     * Adds an item to folder. Item must contain
     * a getJson/fromJson function
     */
    addItem(item) {
        item.parent = this;
        this.items.push(item);
    }

    /**
     * Deletes item from folder. Returns deleted item
     * if any, and undefined if it doesn't exist
     */
    deleteItem(item) {
        let i = this.items.indexOf(item);

        if (i > -1) {
            item.parent = undefined;
            this.items.splice(i, 1);
            return item;
        }

        return undefined;
    }

    deleteFolder(folder) {
        let i = this.subFolders.indexOf(folder);

        if (i > -1) {
            this.subFolders.splice(i, 1);
            return folder;
        }

        return undefined;
    }


    delete() {
        if (this.parent === undefined) {
            return;
        }

        this.parent.deleteFolder(this);
    }

    /**
     * Adds a new folder to folder w/ given name
     * and returns the newly created folder
     */
    newFolder(name) {
        let folder = new Folder(name, this, this.depth + 1);
        this.subFolders.push(folder);
        return folder;
    }

    addFolder(folder) {
        folder.depth = this.depth + 1;
        this.subFolders.push(folder);
    }

    getJson() {
        return {
            name: this.name,
            subFolders: this.subFolders.map(fldr => fldr.getJson()),
            items: this.items.map(item => item.getJson())
        };
    }

    // itemBuilder takes in item json and returns the constructed item
    fromJson(json, itemBuilder) {
        this.name = json.name;
        this.items = json.items.map(item => itemBuilder(item));
        this.items.forEach(item => item.parent = this);
        this.subFolders = json.subFolders.map(
            subFolder => new Folder(undefined, this, this.depth + 1)
                .fromJson(subFolder, itemBuilder));

        return this;
    }

    getAllItems() {
        let items = [... this.items];
        for (let i in this.subFolders) {
            items = items.concat(this.subFolders[i].getAllItems());
        }

        return items;
    }
}

export default Folder;
